"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LoginPage", {
  enumerable: true,
  get: function get() {
    return _LoginPage.LoginPage;
  }
});

var _LoginPage = require("./LoginPage");